import React, { useState } from "react";
import {
  Container,
  Typography,
  Button,
  Box,
  useTheme,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField
} from "@mui/material";
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';
import Giveaway from "./Giveaway.js";
import Register from "./Register";

const HeroSection = () => {
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === "dark";
  const [registerOpen, setRegisterOpen] = useState(false);
  const [giveawayOpen, setGiveawayOpen] = useState(false);
  const [email, setEmail] = useState('');
  const [preloadedEmail, setPreloadedEmail] = useState("");

const handleSubmit = (e) => {
  e.preventDefault();
  setPreloadedEmail(email);
  setRegisterOpen(true);
};

  return (
    <section className="hero">
      <Container maxWidth="lg" sx={{ textAlign: "center", py: 4 }}>
        <Box
          sx={{
            backgroundColor: '#181818',
            color: 'white',
            borderRadius: 4,
            border: '1px solid rgba(255, 255, 255, 0.3)',
            px: { xs: 3, sm: 6 },
            py: { xs: 4, sm: 6 },
            mx: 'auto',
            maxWidth: '960px',
          }}
        >
          <Typography variant="h3" gutterBottom>
            Welcome to
          </Typography>

          <Box sx={{ mt: 4 }}>
            <img
              src={isDarkMode ? "/rocket-stacked-white.png" : "/rocket-stacked-black.png"}
              alt="Rocket Offer Hero"
              style={{
                maxWidth: "100%",
                height: "auto",
                display: "block",
                marginLeft: "auto",
                marginRight: "auto",
              }}
            />
          </Box>

          <Typography variant="h5" sx={{ m: 4 }}>
            Helping homeowners, investors, and agents buy, renovate, and sell homes faster!
          </Typography>

          <Typography variant="h5" sx={{ m: 4 }}>
            Enter your email to get started:
          </Typography>

          <TextField
            variant="outlined"
            placeholder="you@example.com"
            name="email"  // ✅ Critical for formEmail = e.target.email.value to work
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            sx={{
              input: {
                color: 'black', // ← This sets the visible input text color
                backgroundColor: 'white',
                '::placeholder': {
                  color: 'gray',
                  opacity: 1,
                },
              },
              width: { xs: '100%', sm: '320px' },
              borderRadius: 1,
              mb: 2
            }}
          />

          <Button
            variant="contained"
            color="primary"
            size="large"
            startIcon={<RocketLaunchIcon />}
            onClick={handleSubmit}
            sx={{
              height: '56px',
              padding: '0 24px',
              fontSize: '1.1rem',
              border: '2px solid',
              borderColor: 'black',
              boxShadow: 2,
              transition: 'none',
              '&:hover': {
                transform: 'none',
                boxShadow: 3,
              },
            }}
          >
            Get Started
          </Button>
        </Box>
      </Container>

      <Dialog open={registerOpen} onClose={() => setRegisterOpen(false)} fullWidth maxWidth="sm">
        <DialogTitle>Rocket Offer</DialogTitle>
        <DialogContent>
          <Register email={preloadedEmail} />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setRegisterOpen(false)}>Close</Button>
        </DialogActions>
      </Dialog>


      <Dialog open={giveawayOpen} onClose={() => setGiveawayOpen(false)} fullWidth maxWidth="sm">
        <DialogTitle>Enter the RocketOffer.com Giveaway!</DialogTitle>
        <DialogContent>
          <Giveaway />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setGiveawayOpen(false)}>Close</Button>
        </DialogActions>
      </Dialog>
    </section>
  );
};

export default HeroSection;
